module.exports = {
  SSO_SITE: 'https://passport.pcb.elecfans.net',
  HQCHIP_HOST: 'https://www-4.ic.elecfans.net',
  SMT_HOST: 'https://smt-5.ic.elecfans.net',
  SMTSERVICE_HOST: 'https://dev-smt.hqchip.com',
  HQPCB_HOST: 'https://dev-hqpcb-06.elecfans.net',
  CENTER_HOST: 'https://center.ic.elecfans.net',
  CUSTOMER_HOST: 'https://dev-customer.huaqiu.com',
}
